<template>
  <div class="card">
    <div class="card-header">
      {{ title }}
    </div>
    <div class="card-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"],
};
</script>

<style lang="scss" scoped>
.card {
  margin: 10px;
  padding: 0px 10px 4px;
  background: #fff;
  border-radius: 5px;
  .card-header {
    // padding-left: 10px;
    position: relative;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #333333;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    border-bottom: 1px solid #eeeeee;

    // &::after{
    // 	content: "";
    // 	width: 4px;
    // 	height: 15px;
    // 	background-image: linear-gradient(180deg, #62C9FF 0%, #3399FF 100%);
    // 	position: absolute;
    //   left: 0px;
    //   top: 50%;
    //   margin-top: -7.5px;
    // 	border-radius: 2px;
    // }
  }
  .card-content {
    padding: 12px 0;
  }
}
</style>
